import { createI18n } from 'vue-i18n'

const messages = {
    en: {
        // ui static words
        submit: "Submit",
        cancel: "Cancel",
        close: "Close",
        create: "Create",
        languageSwitched: "Language switched successfully!",
        add_new_category: "Add new category",
        category: "Category",
        create_category: "Create category",
        edit_category: "Edit category",
        category_name: "Category name",
        sub_category: "Sub category",
        create_sub_category: "Create sub category",
        add_new_sub_category: "Add new sub category",
        select_category: "Select category",
        select_an_option: "Select an option",
        sub_category_name: "Sub category name",
        enter_sub_category_name: "Enter sub category name",
        enter_category_name: "Enter category name",
        edit_sub_category: "Edit sub category",
        select_a_category: "Select a category",
        item_size: "Size",
        add_new_item_size: "Add new size",
        create_item_size: "Create size",
        item_size_name: "Size name",
        edit_item_size: "Edit size",
        item_color: "Color",
        add_new_item_color: "Add new color",
        create_item_color: "Create color",
        item_color_name: "Color name",
        edit_item_color: "Edit color",
        store: "Store",
        add_new_store: "Add new store",
        store_name: "Store name",
        store_address: "Store address",
        store_phone_number: "Store phone number",
        create_store: "Create store",
        edit_store: "Edit store",
        warehouse: "Warehouse",
        add_new_warehouse: "Add new warehouse",
        warehouse_name: "Warehouse name",
        warehouse_address: "Warehouse address",
        warehouse_phone_number: "Warehouse phone number",
        create_warehouse: "Create warehouse",
        edit_warehouse: "Edit warehouse",
        supplier: "Supplier",
        add_new_supplier: "Add new supplier",
        supplier_name: "Supplier name",
        supplier_address: "Supplier address",
        supplier_phone_number: "Supplier phone number",
        create_supplier: "Create supplier",
        edit_supplier: "Edit supplier",
        measurement_unit: "Measurement unit",
        add_new_measurement_unit: "Add new measurement unit",
        create_measurement_unit: "Create measurement unit",
        edit_measurement_unit: "Edit measurement unit",
        item: 'Item',
        select_item:'Select item',
        add_new_item: 'Add new item',
        item_code: 'Item code',
        item_name: 'Item name',
        sku: 'SKU',
        model_number: 'Model number',
        stock_quantity: 'Stock quantity',
        reorder_level: 'Reorder level',
        manufacturing_date: 'Manufacturing date',
        expire_date: 'Expire date',
        item_serial_number: 'Item serial number',
        barcode_qr_code: 'Barcode',
        purchase_price: 'Purchase price',
        selling_price: 'Selling price',
        discount: 'Discount',
        vat_group: 'Vat group',
        vat_groups: 'Vat groups',
        create_item: 'Create item',
        select_manufacturing_date: 'Select manufacturing date',
        select_expire_date: 'Select expire date',
        new_item: "New item",
        back_to_item: "Back to items",
        general_information: "General information",
        item_details: "Item details",
        inventory_information: "Inventory information",
        item_information: "Item information",
        pricing_information: "Pricing information",
        add_new: "Add new",
        images: "Images",
        add_images: "Add images",
        edit_item: "Edit item",
        image: "Image",
        no_image: "No image",
        income_head_name: "Income head name",
        income_head: "Income head",
        new_income_head: "New income head",
        create_income_head: "Create income head",
        add_new_income_head: "Add new income head",
        edit_income_head: "Edit income head",
        expense_head: "Expense head",
        expense_head_name: "Expense head name",
        add_new_expense_head: "Add new expense head",
        new_expense_head: "New expense head",
        create_expense_head: "Create expense head",
        back_to_list: "Back",
        edit_expense_head: "Edit expense head",
        customer_due: "Customer due",
        add_new_customer_due: "Add new customer due",
        customer_name: "Customer name",
        new_customer_due: "New customer due",
        create_customer_due: "Create customer due",
        edit_customer_due: "Edit customer due",
        supplier_due: "Supplier due",
        add_new_supplier_due: "Add new supplier due",
        new_supplier_due: "New supplier due",
        create_supplier_due: "Create supplier due",
        edit_supplier_due: "Edit supplier due",
        bank_account_list: "Bank account",
        add_new_bank_account: "Add new bank account",
        bank_account_number: "Bank account number",
        new_bank_account: "New bank account",
        create_bank_account: "Create bank account",
        edit_bank_account: "Edit bank account",
        inventory_batch_list:"Purchase",
        add_new_batch:"Add new purchase",
        new_batch:"New purchase",
        search_item_by_name_code:"Search item by name, code",
        add:"Add",
        customer_list:"Customer",
        add_new_customer:"Add new customer",
        edit_customer:"Edit customer",
        new_customer:"New customer",
        create_customer:"Create customer",
        enter_customer_name:"Enter customer name",
        enter_phone_number:"Enter phone number",
        enter_customer_code:"Enter customer code",
        enter_due_limit:"Enter due limit",
        enter_due_limit_days:"Enter due limit days",
        enter_customer_address:"Enter customer address",
        enter_customer_bank:"Enter customer bank",
        enter_contact_person:"Enter contact person",
        enter_email:"Enter email",
        setting_list:"Setting",
        edit_configuration:"Edit configuration",
        select_customer: 'Select customer',
        search_customer_by_name_phone:"Search customer by name, phone",
        select_supplier:"Select supplier",
        search_supplier_by_name_phone:"Search supplier by name, phone",
        item_return_entry:"Sales return",
        customer_due_receive_entry:"Customer due receive",
        supplier_due_entry:"Supplier due payment",
        damage_item_entry:"Damage item",
        select_voucher:'Select voucher',
        search_item_by_name_barcode: 'Search item by name, barcode',
        total_discount:'Total discount',
        total_vat:'Total vat',
        total_price:'Total price',
        return_qty:'Return Qty',
        return_total_price:'Return total price',
        no_data_found:'No Data Found',
        reference_no:"Reference No",
        total:'Total',
        paid:'Paid',
        due:'Due',
        enter_reference_no:"Enter reference no",
        search_voucher_by:"Search invoice by 4",
        search_voucher_by_id:"Search invoice by 7",
        purchase_return:"Purchase return",
        sales_return_list:"Sales return list",
        new_sales_return:"New sales return",
        return_voucher_no:"Return voucher no",
        return_voucher_date:"Return voucher date",
        sales_voucher_no:"Sales voucher no",
        sales_voucher_date:"Sales voucher date",
        total_return_price:"Total return price",
        user_name:"Username",
        user_email:"User email",
        user_group:"User group",
        user_list:"User list",
        user_role: "User role",
        add_new_user: "Add new user",
        edit_user: "Edit user",
        new_user: "New user",
        role_name: "Role name",
        email: "Email",
        password: "Password",
        role_list: "Role list",
        add_new_role: "Add new role",
        new_role: "New role",
        user_type: "User type",
        item_with_stock: "Item with stock ?",
        customer_due_receive_list: "Customer due receive list",
        total_paid_amount: "Total paid amount",
        new_due_receive: "New due receive",
        purchase_return_list: "Purchase return list",
        new_purchase_return: "New purchase return",
        purchase_voucher_no: "Purchase voucher no",
        purchase_voucher_date: "Purchase voucher date",
        supplier_due_payable_list: "Supplier due payable list",
        new_due_pay: "New due pay",
        start_date: "Start date",
        end_date: "End date",
        configuration: "Configuration",
        vat_group_name: "Vat group name",
        vat_value: "Vat value",
        add_new_vat_group: "Add new vat group",
        create_vat_group: "Create vat group",
        edit_vat_group: "Edit vat group",
        barcode_print: "Barcode print",
        total_quantity: "Total quantity",
        print_qty: "Print quantity",
        print_preview: "Print preview",
        invoice_style: "Invoice style",
        invoice_setting: "Invoice setting",
        add_new_setting: "Add new setting",
        business_name: "Business name",
        business_phone: "Business phone",
        business_address: "Business address",
        show_tin: "Show tin",
        show_bin: "Show bin",
        show_logo: "Show logo",
        powered_by: "Powered by",
        edit_setting: "Edit setting",
        create_invoice_setting: "Create invoice setting",
        header_message: "Header message",
        footer_message: "Footer message",
        select_store: "Select store",

        // db table fields
        node: "Category",
        status: "status",
        head_status: "head_status",
        account_id: "Account ID",
        action: "Action",
        created_at: "Created At",
        created_by: "Created By",
        updated_at: "Updated At",
        updated_by: "Updated By",
        size: "Size",
        color: "Color",
        name: "Name",
        address: "Address",
        phone_number: "Phone number",
        unit: "Unit",
        chalan_no:"Chalan no",
        chalan_date:"Chalan date",
        batch_no:" Batch no",
        lot_no:"Lot no",
        costing_unit_price:"Costing unit price",
        quantity:"Quantity",
        total_amount:"Total amount",
        in_house_date:"In house date",
        expiry_date:"Expiry date",
        unit_price:"Unit price",
        amount:"Amount",
        receiving_no:"Voucher no",
        receiving_date:"Voucher date",
        payment_type:"Payment type",
        bank_account: "Bank account",
        customer_code:"Customer code",
        due_limit:"Due limit",
        due_limit_days:"Due limit days",
        customer_address:"Customer address",
        customer_bank:"Customer bank",
        customer_contact_person:"Customer contact person",
        customer_email:"Customer email",
        customer_phone:"Customer phone",
        batch_policy:"Batch policy",
        discount_policy:"Discount policy",
        global_vat_percentage:"Global VAT Percentage (%)",
        vat_policy:"Vat policy",
        voucher_no:"Voucher no",
        voucher_date:"Voucher date",
        narration:"Narration",

        error: {
          required: 'This field is required.',
          invalid_phone: 'Enter a valid phone number (11-15 digits).',
          generic_error: 'Something went wrong, please try again.',
          max_images: "You can only upload a maximum of 2 images.",
        },
    },
    bn: {
        // ui static words
        submit: "সংরক্ষণ করুন",
        cancel: "বাতিল করুন",
        close: "বন্ধ",
        create: "তৈরি করুন",
        languageSwitched: "ভাষা সফলভাবে পরিবর্তিত হয়েছে!",
        add_new_category: "নতুন বিভাগ যোগ করুন",
        category: "বিভাগ",
        create_category: "বিভাগ তৈরি করুন",
        edit_category: "বিভাগ সম্পাদনা করুন",
        category_name: "বিভাগের নাম",
        sub_category: "উপ-বিভাগ",
        create_sub_category: "উপ-বিভাগ তৈরি করুন",
        add_new_sub_category: "নতুন উপ-বিভাগ যোগ করুন",
        select_category: "বিভাগ নির্বাচন করুন",
        select_an_option: "একটি অপশন নির্বাচন করুন",
        sub_category_name: "উপ-বিভাগের নাম",
        enter_sub_category_name: "উপ-বিভাগের নাম লিখুন",
        enter_category_name: "বিভাগের নাম লিখুন",
        edit_sub_category: "উপ-বিভাগ সম্পাদনা করুন",
        select_a_category: "একটি বিভাগ নির্বাচন করুন",
        item_size: "আইটেম সাইজ",
        add_new_item_size: "নতুন আইটেম সাইজ যোগ করুন",
        create_item_size: "আইটেম সাইজ তৈরি করুন",
        item_size_name: "আইটেম সাইজের নাম",
        edit_item_size: "আইটেম সাইজ সম্পাদনা করুন",
        item_color: "আইটেম রং",
        add_new_item_color: "নতুন আইটেম রং যোগ করুন",
        create_item_color: "আইটেম রং তৈরি করুন",
        item_color_name: "আইটেম রঙের নাম",
        edit_item_color: "আইটেম রং সম্পাদনা করুন",
        store: "স্টোর",
        add_new_store: "নতুন স্টোর যোগ করুন",
        store_name: "স্টোরের নাম",
        store_address: "স্টোরের ঠিকানা",
        store_phone_number: "স্টোরের ফোন নম্বর",
        create_store: "স্টোর তৈরি করুন",
        edit_store: "স্টোর সম্পাদনা করুন",
        warehouse: "গুদাম",
        add_new_warehouse: "নতুন গুদাম যোগ করুন",
        warehouse_name: "গুদামের নাম",
        warehouse_address: "গুদামের ঠিকানা",
        warehouse_phone_number: "গুদামের ফোন নম্বর",
        create_warehouse: "গুদাম তৈরি করুন",
        edit_warehouse: "গুদাম সম্পাদনা করুন",
        supplier: "সরবরাহকারী",
        add_new_supplier: "নতুন সরবরাহকারী যোগ করুন",
        supplier_name: "সরবরাহকারীর নাম",
        supplier_address: "সরবরাহকারীর ঠিকানা",
        supplier_phone_number: "সরবরাহকারীর ফোন নম্বর",
        create_supplier: "সরবরাহকারী তৈরি করুন",
        edit_supplier: "সরবরাহকারী সম্পাদনা করুন",
        measurement_unit: "পরিমাপ ইউনিট",
        add_new_measurement_unit: "নতুন পরিমাপ ইউনিট যোগ করুন",
        create_measurement_unit: "পরিমাপ ইউনিট তৈরি করুন",
        edit_measurement_unit: "পরিমাপ ইউনিট সম্পাদনা করুন",
        item: 'আইটেম',
        add_new_item: 'নতুন আইটেম যোগ করুন',
        item_code: 'আইটেম কোড',
        item_name: 'আইটেমের নাম',
        sku: 'এসকেইউ',
        model_number: 'মডেল নম্বর',
        stock_quantity: 'স্টক পরিমাণ',
        reorder_level: 'পুনর্বিন্যাস স্তর',
        manufacturing_date: 'উৎপাদনের তারিখ',
        expire_date: 'মেয়াদ উত্তীর্ণের তারিখ',
        item_serial_number: 'আইটেম সিরিয়াল নম্বর',
        barcode_qr_code: 'বারকোড',
        purchase_price: 'ক্রয় মূল্য',
        selling_price: 'বিক্রয় মূল্য',
        discount: 'ডিসকাউন্ট',
        tax_group: 'ট্যাক্স গ্রুপ',
        create_item: 'আইটেম তৈরি করুন',
        select_manufacturing_date: 'উৎপাদনের তারিখ নির্বাচন করুন',
        select_expire_date: 'মেয়াদ উত্তীর্ণের তারিখ নির্বাচন করুন',
        new_item: "নতুন আইটেম",
        back_to_item: "আইটেমগুলিতে ফিরে যান",
        general_information: "সাধারণ তথ্য",
        item_details: "আইটেম বিবরণ",
        inventory_information: "ইনভেন্টরি তথ্য",
        pricing_information: "মূল্য তথ্য",
        add_new: "নতুন যোগ করুন",
        images: "ছবি",
        add_images: "ছবি যোগ করুন",
        edit_item: "আইটেম সম্পাদনা করুন",
        image: "ছবি",
        no_image: "ছবি নেই",
        income_head_name: "আয়ের খাতের নাম",
        income_head: "আয়ের খাত",
        new_income_head: "নতুন আয়ের খাত",
        create_income_head: "আয়ের খাত তৈরি করুন",
        add_new_income_head: "নতুন আয়ের খাত যোগ করুন",
        edit_income_head: "আয়ের খাত সম্পাদনা করুন",
        expense_head: "খরচের খাত",
        expense_head_name: "খরচের খাতের নাম",
        add_new_expense_head: "নতুন খরচের খাত যোগ করুন",
        new_expense_head: "নতুন খরচের খাত",
        create_expense_head: "খরচের খাত তৈরি করুন",
        back_to_list: "তালিকায় ফিরে যান",
        edit_expense_head: "খরচের খাত সম্পাদনা করুন",
        customer_due: "গ্রাহক বকেয়া",
        add_new_customer_due: "নতুন গ্রাহক বকেয়া যোগ করুন",
        customer_name: "গ্রাহকের নাম",
        new_customer_due: "নতুন গ্রাহক বকেয়া",
        create_customer_due: "গ্রাহক বকেয়া তৈরি করুন",
        edit_customer_due: "গ্রাহক বকেয়া সম্পাদনা করুন",
        supplier_due: "সরবরাহকারীর বকেয়া",
        add_new_supplier_due: "নতুন সরবরাহকারীর বকেয়া যোগ করুন",
        new_supplier_due: "নতুন সরবরাহকারীর বকেয়া",
        create_supplier_due: "সরবরাহকারীর বকেয়া তৈরি করুন",
        edit_supplier_due: "সরবরাহকারীর বকেয়া সম্পাদনা করুন",
        bank_account_list: "ব্যাংক অ্যাকাউন্ট",
        add_new_bank_account: "নতুন ব্যাংক অ্যাকাউন্ট যোগ করুন",
        bank_account_number: "ব্যাংক অ্যাকাউন্ট নাম্বার",
        new_bank_account: "নতুন ব্যাংক অ্যাকাউন্ট",
        create_bank_account: "ব্যাংক অ্যাকাউন্ট তৈরি করুন",
        edit_bank_account: "ব্যাংক অ্যাকাউন্ট সম্পাদনা করুন",
        inventory_batch_list:"ইনভেন্টরি ক্রয়",
        search_item_by_name_code:"নাম, কোড অনুসারে আইটেম অনুসন্ধান করুন",
        add:"যোগ করুন",
        customer_list:"গ্রাহক",
        add_new_customer:"নতুন গ্রাহক যোগ করুন",
        edit_customer:"গ্রাহক সম্পাদনা করুন",
        new_customer:"নতুন গ্রাহক",
        create_customer:"নতুন গ্রাহক তৈরি করুন",
        enter_customer_name:"গ্রাহকের নাম লিখুন",
        enter_phone_number:"ফোন নম্বর লিখুন",
        enter_customer_code:"গ্রাহক কোড লিখুন",
        enter_due_limit:"বকেয়া সীমা লিখুন",
        enter_due_limit_days:"নির্ধারিত সীমা দিন লিখুন",
        enter_customer_address:"গ্রাহকের ঠিকানা লিখুন",
        enter_customer_bank:"গ্রাহকের ব্যাংক অ্যাকাউন্ট লিখুন",
        enter_contact_person:"গ্রাহক যোগাযোগ ব্যক্তি লিখুন",
        enter_email:"ইমেইল লিখুন",
        setting_list:"সেটিং",
        edit_setting:"সেটিং সম্পাদনা করুন",
        select_customer: 'গ্রাহকের নির্বাচন করুন',
        search_customer_by_name_phone:"নাম, ফোন অনুসারে গ্রাহক অনুসন্ধান করুন",
        select_supplier:"সরবরাহকারী নির্বাচন করুন",
        search_supplier_by_name_phone:"নাম, ফোন অনুসারে সরবরাহকারী খুঁজুন",
        item_return_entry:"আইটেম ",
        customers_due_receive_entry:"আইটেম ",
        reference_no:"রেফারেন্স নং",
        total:'মোট টাকা',
        paid:'পরিশোধ',
        due:'বকেয়া',
        enter_reference_no:"রেফারেন্স নম্বর লিখুন",

        // db table fields
        node: "বিভাগ",
        status: "স্ট্যাটাস",
        head_status: "হেড-স্ট্যাটাস",
        account_id: "অ্যাকাউন্ট আইডি",
        action: "কার্যক্রম",
        created_at: "তৈরি হয়েছে",
        created_by: "তৈরি করেছেন",
        updated_at: "আপডেটের তারিখ",
        updated_by: "আপডেট করেছেন",
        size: "সাইজ",
        color: "রং",
        name: "নাম",
        address: "ঠিকানা",
        phone_number: "ফোন নম্বর",
        unit: "ইউনিট",
        chalan_no:"চালান নং",
        chalan_date:"চালান তারিখ",
        batch_no:" ব্যাচ নং",
        lot_no:"লট নং",
        costing_unit_price:"ইউনিট খরচ মূল্য",
        quantity:"পরিমাণ",
        total_amount:"মোট পরিমাণ",
        in_house_date:"ইন-হাউস তারিখ",
        expiry_date:"মেয়াদ শেষ হওয়ার তারিখ",
        unit_price:"ইউনিট মূল্য",
        amount:"টাকা",
        receiving_no:"প্রাপ্তি নম্বর",
        receiving_date:"প্রাপ্তির তারিখ",
        payment_type:"পেমেন্টের ধরন",
        bank_account:"ব্যাংক অ্যাকাউন্ট",
        customer_code:"গ্রাহক কোড",
        due_limit:"বকেয়া সীমা",
        due_limit_days:"নির্ধারিত সীমা দিন",
        customer_address:"গ্রাহকের ঠিকানা",
        customer_bank:"গ্রাহক ব্যাংক",
        customer_contact_person:"গ্রাহক যোগাযোগ ব্যক্তি",
        customer_email:"গ্রাহক ইমেল",
        customer_phone:"গ্রাহকের ফোন",
        batch_policy:"ব্যাচ নীতি",
        discount_policy:"ডিসকাউন্ট নীতি",
        vat_percentage:"ভ্যাট শতাংশ",
        vat_policy:"ভ্যাট নীতি",
        voucher_no:"ভাউচার নং",
        voucher_date:"ভাউচার তারিখ",
        narration:"বর্ণনা",


        error: {
          required: 'এই ক্ষেত্রটি প্রয়োজন।',
          invalid_phone: 'একটি সঠিক ফোন নম্বর (১১-১৫ ডিজিট) দিন।',
          generic_error: 'কিছু ভুল হয়েছে, আবার চেষ্টা করুন।',
          max_images: 'আপনি সর্বোচ্চ ২টি ছবি আপলোড করতে পারবেন।',
        },
    },
};

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: localStorage.getItem('lang') || 'en',
    messages,
});

export default i18n;
